import { useAppState, useAppDispatch } from '../Context'
import LocationZip from './LocationZip'
import LocationSelect from './LocationSelect'
import LocationList from './LocationList'
import Spinner from './Spinner'

function Sidebar({ pageTitle, pageSubtitle }) {
  const dispatch = useAppDispatch()
  const { sidebarOpen, mapVisible, isLoading } = useAppState()

  const handleSidebarToggle = () => {
    dispatch({ type: 'setSidebarOpen', payload: !sidebarOpen })
  }

  const handleMapToggle = () => {
    dispatch({ type: 'setMapVisible', payload: !mapVisible })
  }

  return (
    <aside className={`locations-sidebar ${sidebarOpen ? 'locations-sidebar--opened' : 'locations-sidebar--closed'}`}>
      <div className="relative z-30 py-6 px-4 xl:py-10 xl:px-8 2xl:px-14">
        <h1 className="text-primary h1">
          <div className="text-sm lg:text-lg text-secondary">{pageSubtitle}</div>
          {pageTitle}
        </h1>
        <div className="mt-4 space-y-4 xl:mt-8">
          <LocationZip />
          <LocationSelect />
        </div>
      </div>

      <button
        type="button"
        className="z-20 py-2 px-4 w-full text-sm font-semibold text-center text-white transition-colors md:hidden bg-green hover:bg-blue"
        onClick={handleMapToggle}
      >
        <span className="sr-only">Toggle map</span>
        <span>{mapVisible ? 'Hide Map' : 'Show Map'}</span>
      </button>

      {isLoading && <Spinner />}

      <LocationList />

      <button
        type="button"
        className="hidden absolute -right-5 top-1/2 z-10 w-5 h-28 text-white transition-colors -translate-y-14 md:flex bg-green hover:bg-blue"
        onClick={handleSidebarToggle}
      >
        <span className="sr-only">Toggle sidebar</span>
        <svg viewBox="0 0 8 13" className={`m-auto w-2 ${sidebarOpen ? '' : '-scale-x-100'} `}>
          <path
            d="M6.857 1.93 2.14 6.391l4.717 4.487c.638.591-.408 1.602-1.045.986L.432 6.81c-.23-.222-.23-.592 0-.79L5.812.92c.637-.591 1.683.42 1.045 1.011Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </aside>
  )
}

export default Sidebar
